var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4583 57.2917H41.6667M36.4583 78.125H41.6667M59.8958 57.2917H65.1042M59.8958 78.125H65.1042M83.3333 57.2917H88.5417M83.3333 78.125H88.5417M41.6667 15.625V36.4583M83.3333 15.625V36.4583M31.25 109.375H93.75C102.379 109.375 109.375 102.379 109.375 93.75V41.6667C109.375 33.0372 102.379 26.0417 93.75 26.0417H31.25C22.6206 26.0417 15.625 33.0372 15.625 41.6667V93.75C15.625 102.379 22.6206 109.375 31.25 109.375Z",
    stroke: "#EF233C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.55ef36bfea7358772d08527838ecfd2f.svg";
export { ForwardRef as ReactComponent };